<template>
  <div class="save-tray-block container my-5" id="saveTrayModal">
    <h5 class="save-tray-header text-center">
      {{ $resourceString["virtualtray.Savetray.Header"] }}
    </h5>
    <div class="row" v-if="trayId && !isAdminMode && boardDetails.role == 0">
      <div class="col-12 d-flex mt-2">
        <p class="font-16 mt-2 pl-2">
          <b>{{ $resourceString["common.Label.Note"] }}: </b> {{ $resourceString["virtualtray.Savetray.CopyTrayNote"] }}
        </p>
      </div>
    </div>

    <button
      type="button"
      class="wf-modal-button-close btn button-full"
      @click="
        () => {
          hideModal('save-tray');
          handleCroppedImgData();
        }
      "
    >
      <span
        aria-label="Close modal"
        class="png-icon png-icon-icons-symbols--k-txtclose"
      >
      </span>
    </button>
    <div v-if="!trayId && isAdminMode">
      <h5 class="">
        {{ $resourceString["virtualtray.Savetray.Type.Header"] }}
      </h5>

      <div class="d-flex pb-4">
        <label
          class="border flex-grow-1 custom-control custom-radio mr-4 pl-4 rounded"
          for="radio-personal"
        >
          <input
            id="radio-personal"
            class="custom-control-input"
            type="radio"
            v-model="selectedOption"
            value="virtualTray"
          />
          <div class="custom-control-label">
            <div class="text-size-small font-24">
              {{ $resourceString["virtualtray.Savetray.PersonalTray.Header"] }}
            </div>
          </div>
        </label>

        <label
          class="border flex-grow-1 custom-control custom-radio pl-4 rounded"
          for="radio-brand"
        >
          <input
            class="custom-control-input"
            id="radio-brand"
            type="radio"
            v-model="selectedOption"
            value="premixTray"
          />
          <div class="custom-control-label">
            <div class="text-size-small font-24">
              {{ $resourceString["virtualtray.Savetray.BrandTray.Header"] }}
            </div>
          </div>
        </label>
      </div>
    </div>
    <div class="position-relative">
      <label for="tray-cover-input" class="modal-content border-0">
        {{ $resourceString["virtualtray.Savetray.TrayCover.Label"] }}

        <div class="tray-cover position-relative">
          <input
            id="tray-cover-input"
            class=""
            type="file"
            accept="image/x-png,image/png,image/jpeg"
            ref="fileInput"
            @change="handleFileUpload"
          />
          <span
            v-if="!getCropeedImg"

            class="btn btn-outline-primary"
          >
            {{ $resourceString["virtualtray.Savetray.UploadImage.Button"] }}
          </span>

          <img
            class="h-100"
            v-if="
              ((trayId &&
                !getselectAnotherImage &&
                (!getIsstartOverOrCancel || selectedFileUrlForEdit)) ||
                !getIsstartOverOrCancel) &&
                selectedFileUrl && getCropeedImg
            "
            :src="getCropeedImg"
            :alt="trayName || ''"
          />
          <div
            v-if="getCropeedImg && selectedFileUrl"
            class="on-hover-background-card"
          >
            <a
              class="btn btn-outline-white-warn btn btn-outline-primary"
              rel="noopener"
              >{{
                $resourceString[
                  "virtualtray.Savetray.UploadAnotherImage.Button"
                ]
              }}</a
            >
          </div>
        </div>
      </label>
      <p class="text-danger font-16" v-if="trayImageUploadError">
        {{ $resourceString["virtualtray.Savetray.Validitaion"] }}
      </p>

      <!-- Display the selected image -->
    </div>
    <div class="my-5">
      <label for="tray_name">
        {{ $resourceString["virtualtray.Savetray.TrayName.Label"] }}*
      </label>
      <div class=" mb-4">
        <input
          type="text"
          class="form-control"
          id="tray_name"
          v-model="trayName"
          placeholder="Enter tray name"
          aria-describedby="basic-addon3"
        />
        <p class="text-danger font-16" v-if="trayNameError">
          {{ $resourceString["virtualtray.Savetray.TrayName.Error"] }}
        </p>
      </div>
      <label for="tray-description">
        {{ $resourceString["virtualtray.Savetray.TrayDescription.Label"] }}
      </label>
      <div class="input-group">
        <textarea
          class="form-control"
          id="tray-description"
          v-model="trayDescription"
          aria-label="With textarea"
          placeholder="Describe your tray..."
        ></textarea>
      </div>
      <div class="my-4 d-flex justify-content-end">
        <button
          class="btn btn-outline-primary mx-2"
          @click="
            () => {
              hideModal('save-tray');
              handleCroppedImgData();
            }
          "
        >
          {{ $resourceString["virtualtray.Savetray.Cancel.Button"] }}
        </button>
        <a>
          <button class="btn btn-primary" @click.prevent="saveTrayItem" :disabled = "this.saveTrayDisabled">
            {{ $resourceString["virtualtray.Savetray.Save.Button"] }}
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["boardDetails", "trayId", "isAdminMode", "user"],

  data() {
    return {
      isEdit: false,
      tabValue: "",
      currentUrl: "",
      trayRemovedId: "",
      trayName:
        this.trayId &&
        !(
          this.tabValue === "shared" ||
          (this.tabValue === "premix" && !this.isAdminMode) ||
          (this.boardDetails?.boardDetails?.type  == 1 && !this.isAdminMode) || this.boardDetails?.role == 0 )
          ? this.boardDetails?.boardDetails?.title
          : (this.isAdminMode) ? this.boardDetails?.boardDetails?.title : null,
      trayDescription:
        this.trayId &&
        !(
          this.tabValue === "shared" ||
          (this.tabValue === "premix" && !this.isAdminMode) ||
           (this.boardDetails?.boardDetails?.type  == 1 && !this.isAdminMode)  || this.boardDetails?.role == 0)
          ? this.boardDetails?.boardDetails?.description
          : (this.isAdminMode) ? this.boardDetails?.boardDetails?.description : null,
      trayNameError: false,
      selectedOption: this.boardDetails?.boardDetails?.type == 1 ? "premixTray": "virtualTray",
      selectedFile: null,
      selectedFileUrl:
        this.trayId &&
        !(
          this.tabValue === "shared" ||
          (this.tabValue === "premix" && !this.isAdminMode) ||
          (this.boardDetails?.boardDetails?.type  == 1 && !this.isAdminMode)  || this.boardDetails?.role == 0
        )
          ? this.boardDetails?.boardDetails?.thumbnailPhoto
          : (this.isAdminMode) ? this.boardDetails?.boardDetails?.thumbnailPhoto : null,
      uploadQueue: [],
      selectedFileUrlForEdit:
        this.trayId &&
        !(
          this.tabValue === "shared" ||
          (this.tabValue === "premix" && !this.isAdminMode) ||
            (this.boardDetails?.boardDetails?.type  == 1 && !this.isAdminMode)  || this.boardDetails?.role == 0)
          ? this.boardDetails?.boardDetails?.thumbnailPhoto
          : (this.isAdminMode) ? this.boardDetails?.boardDetails?.thumbnailPhoto : null,
      isUploading: false,
      contentId: "",
      productContentId: "",
      trayImageUploadError: false,
      saveTrayDisabled: false
    };
  },
  async created() {
    let premixOrSharedUrl = document.referrer;
    if (premixOrSharedUrl) {
      let params = new URLSearchParams(new URL(premixOrSharedUrl).search);
      this.tabValue = params.get("tab");
      if (
        this.tabValue === "shared" ||
        (this.tabValue === "premix" && !this.isAdminMode)
      ) {
        this.trayName = "";
        this.trayDescription = "";
        this.selectedFileUrl = "";
      }
    }

    await this.trayEditDetails(this.boardDetails?.boardDetails);
    this.currentUrl = new URL(window.location.href);
  },
  computed: {
    ...mapGetters({
      trayData: "virtualTray/trayData",
      getUploadImageResp: "myTray/getUploadImageResp",
      coverImageCroppings: "myTray/getCoverImageCroppings",
      getblobURL: "myTray/getblobURL",
      trayEditedData: "virtualTray/trayEditedData",
      trayAddedNewData: "virtualTray/trayAddedNewData",
      trayRemovedItems: "virtualTray/trayRemovedItems",
      trayOrders: "virtualTray/trayOrders",
      redirectToMyTray: "myTray/getRedirectToMyTray",
      getIsstartOverOrCancel: "myTray/getIsstartOverOrCancel",
      getselectAnotherImage: "myTray/getselectAnotherImage",
      getShareTrayId: "myTray/getShareTrayId",
    }),
    getCropeedImg() {
      if (!this.trayId && (!this.getUploadImageResp || Object.keys(this.getUploadImageResp).length === 0)) {
        return '';
      }
      else{
      return ((this.trayId && !this.getselectAnotherImage)
        ? this.selectedFileUrlForEdit
        : !this.getIsstartOverOrCancel
        ? `${this.getUploadImageResp &&
            this.getUploadImageResp.link}?&crop=true&anchor=${this
            .coverImageCroppings[0] &&
            this.coverImageCroppings[0].offsetWidth}%2c${this
            .coverImageCroppings[0] &&
            this.coverImageCroppings[0].offsetHeight}&h=${this
            .coverImageCroppings[0] &&
            this.coverImageCroppings[0].height}&w=${this
            .coverImageCroppings[0] && this.coverImageCroppings[0].width}`
        : "");
            }
    }
  },

  methods: {
    ...mapActions({
      trayAlreadyExistResourceString: "myTray/trayAlreadyExistResourceString",
      createTray: "myTray/createTray",
      selectedFileOnSaveModal: "myTray/selectedFileOnSaveModal",
      selectedFileUrlOnSaveModal: "myTray/selectedFileUrlOnSaveModal",
      selectedTray: "myTray/selectedTray",
      trayEditDetails: "myTray/trayEditDetails",
      UpdateTray: "myTray/UpdateTray",
      setSelectedTray: "myTray/setSelectedTray",
      startOver: "virtualTray/startOver",
      resourceString: "myTray/resourceString",
      CoverImageCroppingsAction: "myTray/CoverImageCroppingsAction",
      updateImageResp: "myTray/updateImageResp",
      toast: "notifications/add",
      selectAnotherImage:"myTray/selectAnotherImage",
      updateImageBlobd: "myTray/updateImageBlobd"
    }),
    showModal(name) {
      this.$modal.show(name + "-modal");
    },
    handleImageLoadError() {
      //console.log("Image could not be loaded. Preview Not Available.");
    },
    setTrayItem(item, IsNewItem) {
      const trayObj = {
        sellingStyleNumber: item.sellingStyleNumber,
        sellingColorNumber: item.colorNumber,
        quantity: 1.0,
        vehicleId: item.vehicleId,
        isTrayItem: true,
        imageXIndex:item.isRotated ? 1 : 0,
        imageYIndex:item.imageZIndex,
        imageLink: item.imagePath,
        colorName: item.colorName,
        colorNumber: item.colorNumber,
        isFeatureImage: item.isFeatureImage,
        row: item.tileLeftOffset,
        column: item.tileTopOffset,
        swatchWidth: item.swatchWidth,
        swatchLength: item.swatchLength,
        pdmsLink: item.pdmsLink,
        sellingStyleName: item.sellingStyleName,
        tileWidth: item.tileWidth,
        tileHeight: item.tileHeight,
        tileLeftOffset: item.tileLeftOffset,
        tileTopOffset: item.tileTopOffset,
        hexColor: item.hexColor,
        inventoryType: item.inventoryType,
        inventoryStyleNumber: item.inventoryStyleNumber,
        IsNewItem: IsNewItem,
        productType: item.productType,
        IsPositionChange:  IsNewItem ? false : this.isTilePositionChanges(item),
        ContentItemId: this.getContentItemId(item.colorNumber,item.sellingStyleNumber),
        TrayItemId: this.deletedItemId(item.colorNumber,item.sellingStyleNumber,item.imageId),
        ProductContentId: !IsNewItem
          ? this.getProductContentItemId(item.colorNumber,item.sellingStyleNumber)
          : "00000000-0000-0000-0000-000000000000"
      };
      return trayObj;
    },
    async saveTrayItem() {
      if (this.trayName) {
        this.saveTrayDisabled = true;
        const trayDetail = Object.values(this.trayData)?.map((item, index) => ({
          sellingStyleNumber: item.sellingStyleNumber,
          sellingColorNumber: item.colorNumber,
          quantity: 1.0,
          vehicleId: item.vehicleId,
          isTrayItem: true,
          imageXIndex:item.isRotated ? 1 : 0,
          imageYIndex: item.imageZIndex,
          imageLink: item.imagePath,
          colorName: item.colorName,
          colorNumber: item.colorNumber,
          isFeatureImage: item.isFeatureImage,
          row: item.tileLeftOffset,
          column: item.tileTopOffset,
          swatchWidth: item.swatchWidth,
          swatchLength: item.swatchLength,
          tileWidth: item.tileWidth,
          tileHeight: item.tileHeight,
          tileLeftOffset: item.tileLeftOffset,
          tileTopOffset: item.tileTopOffset,
          hexColor: item.hexColor,
          inventoryType: item.inventoryType,
          inventoryStyleNumber: item.inventoryStyleNumber,
          pdmsLink: item.pdmsLink,
          sellingStyleName: item.sellingStyleName,
          productType: item.productType
        }));

        let data = {
          CreateBoardDetail: {
            culture: "en-us",
            title: this.trayName,
            description: this.trayDescription,
            row: "1",
            column: "2",
            croppedBlobs: {
              thumbnail: this.getblobURL
            },
            coverImageCroppings: this.coverImageCroppings
              ? this.coverImageCroppings
              : [],
            coverImage: {
              assetId: this.getUploadImageResp?.id
            },
            coverPhoto: this.getUploadImageResp?.link,
            isBrandBoard: this.selectedOption === "virtualTray" ? false : true,
            accessLevel: this.selectedOption === "premixTray" ? 2 : null,
            type: (this.selectedOption === "premixTray" && this.isAdminMode) ? 1 : 0,
            siteProjectName: "VirtualTray"
          },
          CartItems: trayDetail
        };

        if ( (this.isAdminMode && this.trayId) ||
          (this.trayId &&
          !(
            this.tabValue === "shared" ||
            (this.tabValue === "premix" && !this.isAdminMode) ||
            (this.boardDetails?.boardDetails?.type  == 1 && !this.isAdminMode)  || this.boardDetails?.role == 0
          ))
        ) {
          this.setSelectedTray(this.selectedOption);

          const trayEditDetailNew = Object.values(
            this.trayEditedData
          )?.map(item => this.setTrayItem(item, false));

          const editTrayDetail = Object.values(
            this.trayAddedNewData
          )?.map(item => this.setTrayItem(item, true));

          let resDetail = [...trayEditDetailNew, ...editTrayDetail];

          const RemovedTray = this.trayRemovedItems?.map(item => ({
            ContentItemId: this.getContentItemId(item.colorNumber,item.sellingStyleNumber),
            ProductContentId: this.getProductContentItemId(item.colorNumber,item.sellingStyleNumber),
            RemovedItems: this.deletedItemId(item.colorNumber,item.sellingStyleNumber,item.imageId),
            SellingStyleNumber: item.sellingStyleNumber
          }));

          let updateTrayModel = {
            UpdateBoardDetail: {
              culture: "en-us",
              Id: this.boardDetails?.boardDetails?.id,
              IsUpdate: this.boardDetails?.isUpdate,
              title: this.trayName,
              description: this.trayDescription,
              row: "1",
              column: "2",
              croppedBlobs: {
                thumbnail: this.getblobURL
              },
              coverImageCroppings: this.coverImageCroppings
                ? this.coverImageCroppings
                : [],
              coverImage: {
                assetId: this.getUploadImageResp?.id
              },
              coverPhoto: this.getUploadImageResp?.link,
              isBrandBoard:
                this.selectedOption === "virtualTray" ? false : true,
              accessLevel: this.selectedOption === "premixTray" ? 2 : null,
              type: (this.selectedOption === "premixTray"  && this.isAdminMode)? 1 : 0,
              siteProjectName: "VirtualTray"
            },
            CartItems: resDetail,
            RemovedTrayItems: RemovedTray
          };

          await this.resourceString(
            this.$resourceString["virtualtray.Tray.Updated.Msg"]
          );

          await this.trayAlreadyExistResourceString(
            this.$resourceString["virtualTray.Request.DuplicateName"]
          );
          if(await this.UpdateTray(updateTrayModel) && this.boardDetails?.boardDetails?.id)
          {
            document.body.onbeforeunload = "";
            window.location.href = "/virtualtray/edittray/" + this.boardDetails?.boardDetails?.id;
            await this.hideModal("save-tray");
          } 

        } else {
          this.setSelectedTray(this.isAdmin ? this.selectedOption :"virtualTray");
          await this.resourceString(
            this.$resourceString["virtualtray.Tray.Created.Msg"]
          );
          await this.trayAlreadyExistResourceString(
            this.$resourceString["virtualTray.Request.DuplicateName"]
          );
          if(await this.createTray({trayDetail: data, isCallFromMyProject: false}) == true){
            // await this.startOver();
            document.body.onbeforeunload = "";
            window.location.href = "/virtualtray/edittray/" + this.getShareTrayId;
          }
          await this.hideModal("save-tray");
        }
        this.saveTrayDisabled = false;
        // await this.showModal("redirect-confirm")
      } else {
        this.trayNameError = true;
      }
    },
    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },
    handleCroppedImgData() {
      this.updateImageResp({ data: "" });
      this.CoverImageCroppingsAction([]);
      this.selectAnotherImage(false)
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    async handleFileUpload(event) {
      let compressedImage;
      if (this.isUploading) {
        // If an upload is already in progress, queue the file for later
        this.uploadQueue.push(event.target.files[0]);
        return;
      }

      const file = event.target.files[0];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      // Check if the file is a JPEG or PNG image
      if (
        file &&
        file.size < maxSize &&
        (file.type === "image/jpeg" || file.type === "image/png")
      ) {
        compressedImage = await this.compressAndResizeImage(
          file,
          1500,
          1500,
          2 * 1024 * 1024
        );
        this.selectedFile = file;
        if(compressedImage){

        this.selectedFileOnSaveModal(compressedImage);
        this.selectedFileUrlOnSaveModal(URL.createObjectURL(compressedImage));

        this.selectedFileUrl = URL.createObjectURL(compressedImage);
        this.showModal("upload-image");
        this.trayImageUploadError = false;

        this.$refs.fileInput.value = null;
        }
      } else {
        // Invalid file type, clear the selection
        this.selectedFile = null;
        this.selectedFileUrl = null;
        this.trayImageUploadError = true;
        //console.log("Please select a valid JPEG or PNG image.");
      }
    },
    handleUpload() {
      document.getElementById("tray-cover-input").click();
    },
    getContentItemIds() {
      this.boardDetails?.boardDetails?.sections?.forEach(section => {
        section?.contentItems?.forEach(contentItem => {
          return (this.contentId = contentItem.id);
        });
      });
    },
    getProductContentItemIds() {
      this.boardDetails?.boardDetails?.sections?.forEach(section => {
        section?.contentItems?.forEach(contentItem => {
          if (contentItem.productContentItem) {
            return (this.productContentId = contentItem.productContentItem.id);
          }
        });
        return this.productContentId;
      });
    },
    getProductContentItemId(colorNumber,sellingStyleNumber) {
      let productId = null;
      let editData = this.boardDetails?.boardDetails?.sections.find(
        e => e.title == "default"
      );
      for (let i = 0; i < editData?.contentItems?.length; i++) {
        for (const item of editData?.contentItems[i]?.productContentItem
          ?.productStyleImages || []) {
          if (item?.colorNumber == colorNumber ) {
            if(editData?.contentItems[i]?.productContentItem?.productId == sellingStyleNumber){
            productId = editData?.contentItems[i]?.productContentItem?.id;
            return productId;
            }
          }
        }
      }

      return productId;
    },
    getContentItemId(colorNumber,sellingStyleNumber) {
      let productId = null;
      let editData = this.boardDetails?.boardDetails?.sections.find(
        e => e.title == "default"
      );

      for (let i = 0; i < editData?.contentItems?.length; i++) {
        for (const item of editData?.contentItems[i]?.productContentItem
          ?.productStyleImages || []) {
          if (item?.colorNumber == colorNumber) {
            if(editData?.contentItems[i]?.productContentItem?.productId == sellingStyleNumber){

            productId = editData?.contentItems[i]?.id;
            return productId;
          }
        }
        }
      }

      return productId;
    },
    deletedItemId(colornumber,sellingStyleNumber,id) {
      let contentId = "";
      let editData = this.boardDetails?.boardDetails?.sections.find(
        e => e.title == "default"
      );
      for (let i = 0; i < editData?.contentItems?.length; i++) {
        editData?.contentItems[
          i
        ]?.productContentItem?.productStyleImages?.forEach(item => {
          if (item.colorNumber == colornumber && item.id == id) {
            if(editData?.contentItems[i]?.productContentItem?.productId == sellingStyleNumber){
            contentId = item.id;
            if (contentId != "") {
              return;
            }
          }
        }
        });
        if (contentId != "") {
          break;
        }
      }
      return contentId;
    },
    isTilePositionChanges(itemData) {
      if (this.boardDetails?.boardDetails) {
        let editData = this.boardDetails?.boardDetails?.sections.find(e => e.title === "default");

        for (const element of editData.contentItems) {
          for (const item of element.productContentItem.productStyleImages) {

            if (
              item.colorNumber == itemData.colorNumber &&
              element.productContentItem.productId == itemData.sellingStyleNumber &&
              item.id == itemData.imageId &&
              item.imageYIndex == itemData.imageZIndex &&
              (item.tileTopOffset == Number(itemData.tileTopOffset) && item.tileLeftOffset == Number(itemData.tileLeftOffset) && (item.imageXIndex != 0) == itemData.isRotated)
            ){

              return false;
            }

          }
        }
      }
      return true;
    },
    compressAndResizeImage(imageFile, maxWidth, maxHeight, maxSizeInBytes) {
      // const maxSizeInBytes = 2 * 1024 * 1024; // 2MB
      return new Promise(resolve => {
        const image = new Image();
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        image.onload = () => {
          let newWidth = image.width;
          let newHeight = image.height;

          // Adjust the image dimensions
          if (image.width > maxWidth) {
            newWidth = maxWidth;
            newHeight = (image.height * maxWidth) / image.width;
          }

          if (newHeight > maxHeight) {
            newHeight = maxHeight;
            newWidth = (image.width * maxHeight) / image.height;
          }

          canvas.width = newWidth;
          canvas.height = newHeight;

          ctx?.drawImage(image, 0, 0, newWidth, newHeight);

          canvas.toBlob(blob => {
            if (blob && blob.size <= maxSizeInBytes) {
              // Use the original image format instead of 'image/jpeg'
              const compressedFile = new File([blob], imageFile.name, {
                type: imageFile.type
              });
              resolve(compressedFile);
            } else {
              // Handle the case where the compressed image is too large
              this.toast(
                {
                  type: "success",
                  title: "File size should be less than 2MB",
                  description: ""
                },
                { root: true }
              );
              resolve(null);
            }
          }, imageFile.type);
        };

        image.src = URL.createObjectURL(imageFile);
      });
    }
  },
  mounted() {
    this.getProductContentItemIds();
    this.getContentItemIds();
  }
};
</script>
